import { PostProcessorModule } from 'i18next';

/**
 * Идентификация пола, принятая во ВКонтакте
 */
export const VkSex = {
  Female: 1,
  Male: 2,
  Unknown: 0,
} as const;

export type VkSex = Union<typeof VkSex>;

export const Sex: PostProcessorModule = {
  name: 'sex',
  type: 'postProcessor',
  process(value, keys, options, translator) {
    if (![VkSex.Unknown, VkSex.Male, VkSex.Female].includes(options.sex)) {
      return value;
    }

    const { sex, context, ...restOptions } = options;

    const suffix = sex === VkSex.Female ? '_plural' : '';
    const key = `${keys[0]}${context ? translator.options.contextSeparator + context : ''}${suffix}`;
    const processedValue = translator.translate(key, restOptions);

    return processedValue === key ? value : processedValue;
  },
};
